/**
 * Custom Script: Prevent purchasing  Gift items
 */
(function() {
    // ==== Toast Notification ====
    function showToast(message, duration = 3000) {
        let container = document.querySelector('.tl-toast-container');
        if (!container) {
            container = document.createElement('div');
            container.className = 'tl-toast-container';
            document.body.appendChild(container);
        }
        const toast = document.createElement('div');
        toast.className = 'tl-toast';
        toast.innerHTML = `
            <svg class="tl-toast-icon" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="#FFB020" stroke-width="2"/>
                <path d="M12 8V13" stroke="#FFB020" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="16" r="1" fill="#FFB020"/>
            </svg>
            <span class="tl-toast-message">${message}</span>
        `;
        container.appendChild(toast);
        requestAnimationFrame(() => toast.classList.add('tl-toast-show'));
        setTimeout(() => {
            toast.classList.remove('tl-toast-show');
            toast.classList.add('tl-toast-hide');
            setTimeout(() => toast.remove(), 300);
        }, duration);
    }

    // ==== Kiểm tra xem variant có là gift trong giỏ hàng không ====
    // Lấy từ Cart API để đảm bảo chính xác 100%
    async function isGiftInCart(variantId) {
        if (!variantId) return false;
        try {
            const rootUrl = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
            const res = await fetch(rootUrl + 'cart.js');
            const cart = await res.json();

            for (const item of cart.items) {
                // Shopify: item.id = variant_id, item.variant_id = variant_id
                const sameVariant = String(item.id) === String(variantId) 
                                 || String(item.variant_id) === String(variantId);

                if (sameVariant) {
                    const props = item.properties || {};

                    // 1. Kiểm tra Free Gift app: có property _tl_salepify_rule hay tương tự
                    const isFreeGiftProp = Object.keys(props).some(key => 
                        key.startsWith('_tl') || key === '_is_free_gift'
                    );

                    // 2. Kiểm tra Progress Bar: có property _salepify-cart-goal
                    const isCartGoalProp = Object.keys(props).some(key => 
                        key.includes('salepify') || key.includes('cart-goal')
                    );

                    // 3. Giá = 0 (Luôn là dấu hiệu chắc chắn nhất)
                    const isPriceFree = item.price === 0;

                    if (isFreeGiftProp || isCartGoalProp || isPriceFree) {
                        return true;
                    }
                }
            }
            return false;
        } catch(e) {
            console.warn('[Prevent Gift] Cart check error:', e);
            return false;
        }
    }

    // ==== Chặn Form Submit (Product Page - Add to Cart button) ====
    document.addEventListener('submit', async function(e) {
        if (!e.target || !e.target.action || !e.target.action.includes('/cart/add')) return;

        const formData = new FormData(e.target);
        let variantId = formData.get('id');

        // Một số theme dùng items[0][id]
        if (!variantId) {
            for (let [key, val] of formData.entries()) {
                if (key.includes('[id]') || key === 'id') { variantId = val; break; }
            }
        }

        if (variantId) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const isGift = await isGiftInCart(variantId);
            if (isGift) {
                showToast("This product is already in your cart as a free gift. You cannot purchase it.");
                return;
            }

            // Nếu không phải gift, submit lại form thật
            e.target.submit();
        }
    }, true);

    // ==== Chức năng vô hiệu hóa nút Add to Cart trên Product Page ====
    async function disableAddToCartIfGift() {
        const urlParams = new URLSearchParams(window.location.search);
        let currentVariantId = urlParams.get('variant');
        if (!currentVariantId) {
            const variantInput = document.querySelector('input[name="id"]');
            if (variantInput) currentVariantId = variantInput.value;
        }
        if (!currentVariantId) return;

        const isGift = await isGiftInCart(currentVariantId);
        const buttons = document.querySelectorAll(
            'button[name="add"], input[name="add"], button[type="submit"].product-form__submit'
        );

        if (isGift) {
            buttons.forEach(btn => {
                btn.disabled = true;
                if (!btn.dataset.originalText) btn.dataset.originalText = btn.innerHTML;
                btn.innerHTML = "Already in cart";
            });
        } else {
            buttons.forEach(btn => {
                btn.disabled = false;
                if (btn.dataset.originalText) {
                    btn.innerHTML = btn.dataset.originalText;
                    delete btn.dataset.originalText;
                }
            });
        }
    }

    // ==== Lắng nghe sự kiện ====
    window.addEventListener('load', () => setTimeout(disableAddToCartIfGift, 1000));

    // Đổi variant trên Product Page
    document.addEventListener('change', () => setTimeout(disableAddToCartIfGift, 300));

    // Cart update từ Free Gift app
    ['TLFREEGIFT:update', 'TLFREEGIFT:change', 'TLCARTGOAL:add', 'TLCARTGOAL:update'].forEach(evt => {
        window.addEventListener(evt, () => setTimeout(disableAddToCartIfGift, 500));
    });
})();


// disable link free gift
(function() {
  'use strict';

  try {
    // Dữ liệu lưu trữ các định danh của Free Gift trong cart
    var freeGiftData = {
      keys: new Set(),
      variantIds: new Set(),
      pureGiftHandles: new Set(),
      lineIndices: new Set()
    };

    // 1. Kiểm tra text giá có phải bằng 0 hoặc Miễn phí không
    function isZeroPriceText(text) {
      try {
        if (!text) return false;
        var clean = text.trim().toLowerCase();
        // Kiểm tra các từ khóa Free / Miễn phí hoặc 0đ, 0 vnd
        if (/free|miễn phí|gratis|kostenlos|gratuit|0[\s\.,]*đ|0[\s\.,]*vnd/i.test(clean)) {
          return true;
        }
        var digits = clean.replace(/[^0-9]/g, '');
        if (digits.length > 0 && Number(digits) === 0) {
          return true;
        }
      } catch (e) {}
      return false;
    }

    // 2. Kiểm tra 1 item trong cart.js có phải là Free Gift không
    function isCartItemGift(item) {
      try {
        if (!item) return false;

        // Kiểm tra properties đặc trưng của app Salepify và các app Free Gift
        var props = item.properties || {};
        var hasGiftProp = Object.keys(props).some(function(k) {
          var lk = k.toLowerCase();
          return lk.indexOf('_salepify') === 0 ||
                 lk.indexOf('freegift') !== -1 ||
                 lk.indexOf('free_gift') !== -1 ||
                 lk.indexOf('free-gift') !== -1 ||
                 lk === '_is_freegift' ||
                 lk === '_gift';
        });
        if (hasGiftProp) return true;

        // Kiểm tra giá = 0 hoặc giảm giá 100%
        if (item.final_price === 0 || item.price === 0) return true;
        if (item.original_line_price > 0 && item.final_line_price === 0) return true;

        // Kiểm tra discount titles
        if (Array.isArray(item.discounts)) {
          var hasGiftDiscount = item.discounts.some(function(d) {
            var title = (d.title || '').toLowerCase();
            return title.indexOf('free') !== -1 || title.indexOf('gift') !== -1;
          });
          if (hasGiftDiscount && (item.final_price === 0 || item.total_discount >= item.original_price)) {
            return true;
          }
        }
      } catch (e) {}
      return false;
    }

    // 3. Cập nhật dữ liệu Free Gift từ cart object
    function updateCartData(cart) {
      try {
        if (!cart || !Array.isArray(cart.items)) return;

        var keys = new Set();
        var variantIds = new Set();
        var lineIndices = new Set();
        var giftHandlesCount = {};
        var totalHandlesCount = {};

        cart.items.forEach(function(item, index) {
          try {
            var handle = item.handle;
            totalHandlesCount[handle] = (totalHandlesCount[handle] || 0) + 1;

            if (isCartItemGift(item)) {
              if (item.key) keys.add(String(item.key));
              if (item.id) variantIds.add(String(item.id));
              if (item.variant_id) variantIds.add(String(item.variant_id));
              lineIndices.add(index + 1); // Shopify line index là 1-based
              giftHandlesCount[handle] = (giftHandlesCount[handle] || 0) + 1;
            }
          } catch (e) {}
        });

        var pureGiftHandles = new Set();
        Object.keys(giftHandlesCount).forEach(function(handle) {
          if (giftHandlesCount[handle] === totalHandlesCount[handle]) {
            pureGiftHandles.add(handle);
          }
        });

        freeGiftData = {
          keys: keys,
          variantIds: variantIds,
          pureGiftHandles: pureGiftHandles,
          lineIndices: lineIndices
        };
      } catch (e) {}
    }

    // 4. Lấy dữ liệu giỏ hàng qua /cart.js
    function fetchCartData() {
      try {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(res) {
            return res.ok ? res.json() : null;
          })
          .then(function(cart) {
            if (cart) {
              updateCartData(cart);
              disableFreeGiftLinksInDOM();
            }
          })
          .catch(function() {});
      } catch (e) {}
    }

    // 5. Kiểm tra xem phần tử có đang nằm trong Cart (Drawer, Cart Page, Mini Cart) không
    function isInsideCart(el) {
      try {
        if (!el) return false;
        if (window.location.pathname.indexOf('/cart') !== -1) return true;
        var cartContainer = el.closest(
          '.cart-item, .cart__item, .line-item, [data-cart-item], [data-line-item], ' +
          'cart-drawer, cart-drawer-items, #CartDrawer, #cart-drawer, .cart-drawer, ' +
          '.mini-cart, .ajax-cart, .drawer__cart, [data-cart-drawer], [data-cart-items], ' +
          '#main-cart-items, .cart__items, form[action*="/cart"]'
        );
        return Boolean(cartContainer);
      } catch (e) {
        return false;
      }
    }

    // 6. Kiểm tra xem 1 container hoặc link có phải là Free Gift không
    function isFreeGiftElement(container, link) {
      try {
        if (!container && !link) return false;

        // Check thuộc tính/class đánh dấu trực tiếp
        if (container) {
          if (container.getAttribute('data-is-gift') === 'true' ||
              container.classList.contains('is-free-gift') ||
              container.classList.contains('salepify-free-gift')) {
            return true;
          }
        }

        // So khớp với dữ liệu từ cart.js
        if (container) {
          var removeOrActionEl = container.querySelector(
            'a[href*="/cart/change"], button[data-key], [data-line-item-key], ' +
            '[data-cart-remove-id], cart-remove-button, .cart-remove-button, input[name^="updates"]'
          );

          if (removeOrActionEl) {
            var keyAttr = removeOrActionEl.getAttribute('data-key') ||
                          removeOrActionEl.getAttribute('data-line-item-key') ||
                          removeOrActionEl.getAttribute('data-cart-remove-id');
            if (keyAttr && freeGiftData.keys.has(String(keyAttr))) return true;

            var indexAttr = removeOrActionEl.getAttribute('data-index');
            if (indexAttr && freeGiftData.lineIndices.has(Number(indexAttr))) return true;

            var actionHref = removeOrActionEl.getAttribute('href') || '';
            if (actionHref.indexOf('/cart/change') !== -1) {
              try {
                var url = new URL(actionHref, window.location.origin);
                var idParam = url.searchParams.get('id');
                if (idParam && (freeGiftData.keys.has(idParam) || freeGiftData.variantIds.has(idParam))) {
                  return true;
                }
                var lineParam = url.searchParams.get('line');
                if (lineParam && freeGiftData.lineIndices.has(Number(lineParam))) {
                  return true;
                }
              } catch (e) {}
            }
          }

          if (container.id) {
            var matchIndex = container.id.match(/-(\d+)$/);
            if (matchIndex && freeGiftData.lineIndices.has(Number(matchIndex[1]))) {
              return true;
            }
          }
        }

        // So khớp variant ID hoặc handle trên link
        if (link) {
          var href = link.getAttribute('href') || link.getAttribute('data-original-href') || '';
          try {
            var linkUrl = new URL(href, window.location.origin);
            var vParam = linkUrl.searchParams.get('variant');
            if (vParam && freeGiftData.variantIds.has(vParam)) return true;

            var handleMatch = linkUrl.pathname.match(/\/products\/([^\/\?#]+)/);
            if (handleMatch && freeGiftData.pureGiftHandles.has(handleMatch[1])) {
              return true;
            }
          } catch (e) {}
        }

        // Fallback kiểm tra hiển thị giá = 0đ/Free trong DOM
        if (container) {
          var priceEls = container.querySelectorAll(
            '.price--end, .price, .cart-item__price, .cart-item__final-price, ' +
            '.line-item__price, [data-cart-item-price], .final-price, .cart__price, .price__regular'
          );
          for (var i = 0; i < priceEls.length; i++) {
            var pEl = priceEls[i];
            if (pEl.closest('s, del, .cart-item__old-price, .price--compare')) continue;
            if (isZeroPriceText(pEl.textContent)) {
              return true;
            }
          }

          // Kiểm tra nhãn properties hiển thị trong DOM
          var propEls = container.querySelectorAll(
            '.product-option, .cart-item__property, .line-item__property, .discounts__discount'
          );
          for (var j = 0; j < propEls.length; j++) {
            var optText = propEls[j].textContent.toLowerCase();
            if (optText.indexOf('salepify') !== -1 ||
                optText.indexOf('free gift') !== -1 ||
                optText.indexOf('freegift') !== -1 ||
                optText.indexOf('quà tặng') !== -1) {
              return true;
            }
          }
        }
      } catch (e) {}
      return false;
    }

    // 7. Quét DOM để gắn class vô hiệu hóa link cho các Free Gift
    function disableFreeGiftLinksInDOM() {
      try {
        var cartItemSelectors = [
          '.cart-item',
          '.cart__item',
          '.line-item',
          '[data-cart-item]',
          '[data-line-item]',
          'cart-drawer-items tr',
          '#CartDrawer-Item',
          '.cart-drawer-item',
          '.cart-drawer__item'
        ].join(',');

        var containers = document.querySelectorAll(cartItemSelectors);
        containers.forEach(function(container) {
          try {
            var links = container.querySelectorAll('a[href*="/products/"], a[data-original-href*="/products/"]');
            if (links.length === 0) return;

            var isGift = isFreeGiftElement(container, links[0]);
            if (isGift) {
              links.forEach(function(link) {
                try {
                  link.classList.add('fg-disabled-link');
                  link.setAttribute('tabindex', '-1');
                  link.setAttribute('aria-disabled', 'true');
                  link.setAttribute('data-fg-disabled', 'true');
                  
                  // Lưu lại href gốc và xóa href để chặn mở tab mới khi click chuột phải
                  if (link.hasAttribute('href') && link.getAttribute('href') !== 'javascript:void(0);') {
                    link.setAttribute('data-original-href', link.getAttribute('href'));
                    link.setAttribute('href', 'javascript:void(0);');
                  }
                } catch (e) {}
              });
            }
          } catch (e) {}
        });
      } catch (e) {}
    }

    // 8. Bắt sự kiện CLICK trên toàn trang (Event Delegation ở phase Capture)
    document.addEventListener('click', function(e) {
      try {
        var link = e.target.closest('a');
        if (!link) return;

        // Bỏ qua nếu người dùng bấm vào nút Xóa (Remove), Thay đổi số lượng, hoặc nút Checkout
        if (e.target.closest('button, input, select, cart-remove-button, [data-cart-remove], .cart-remove-button, .quantity')) {
          return;
        }

        // Chỉ xử lý các link nằm bên trong Cart
        if (!isInsideCart(link)) return;

        // Kiểm tra xem link có phải dẫn tới Product Page không
        var href = link.getAttribute('href') || link.getAttribute('data-original-href') || '';
        var isProductLink = href.indexOf('/products/') !== -1 || link.getAttribute('data-fg-disabled') === 'true';
        if (!isProductLink) return;

        var container = link.closest(
          '.cart-item, .cart__item, .line-item, [data-cart-item], [data-line-item], ' +
          'cart-drawer-items tr, .cart-drawer-item, .cart-drawer__item, li, tr'
        );

        // Nếu là Free Gift -> Chặn hoàn toàn hành động chuyển trang
        if (link.getAttribute('data-fg-disabled') === 'true' || isFreeGiftElement(container, link)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      } catch (err) {
        // Try-catch an toàn tuyệt đối, đảm bảo các action khác không bị gián đoạn
      }
    }, true);

    // Khởi chạy quét lần đầu
    fetchCartData();

    // 9. Lắng nghe thay đổi DOM (khi Cart Drawer mở ra hoặc re-render AJAX)
    var debounceTimer = null;
    var observer = new MutationObserver(function() {
      try {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          try {
            disableFreeGiftLinksInDOM();
          } catch (e) {}
        }, 80);
      } catch (e) {}
    });

    try {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    } catch (e) {}

    // 10. Lắng nghe các event cart phổ biến trong Shopify & Salepify
    [
      'cart:updated',
      'cart:refresh',
      'shopify:cart:lines-update',
      'cart:build',
      'TLFREEGIFT:add',
      'TLFREEGIFT:update',
      'TLFREEGIFT:change'
    ].forEach(function(evtName) {
      try {
        document.addEventListener(evtName, fetchCartData);
      } catch (e) {}
    });

    // 11. Hook nhẹ vào fetch để tự cập nhật khi có request cart
    var originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function() {
        var args = arguments;
        return originalFetch.apply(this, args).then(function(res) {
          try {
            var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');
            if (url && (
              url.indexOf('/cart/add') !== -1 ||
              url.indexOf('/cart/change') !== -1 ||
              url.indexOf('/cart/update') !== -1 ||
              url.indexOf('/cart/clear') !== -1
            )) {
              setTimeout(fetchCartData, 250);
            }
          } catch (e) {}
          return res;
        });
      };
    }

  } catch (globalErr) {
    // Đảm bảo an toàn 100%, không bao giờ ảnh hưởng tới chức năng khác của website
  }
})();